import React from "react";
import { UISref } from "@uirouter/react";
import styled from "styled-components";

import DetailsInfoSection from "./DetailsInfoSection";
import BranchPhones from "./BranchPhones";

const Wrapper = styled.div`
    margin-right: 10px;
    p {
        margin: 0 !important;
    }
    color: #6c6c6c;
    font-size: 14px;
`;

const MoreLocationsWrapper = styled.div`
    padding-top: 25px;
    display: block;
    font-size: 16px;
`;

const DetailsInfo = ({ location }) => (
    <Wrapper>
        {(location.addressline1 || location.addressCityStateZip) && (
            <DetailsInfoSection
                heading={`Location${
                    location.mailingaddressline1 && location.addressCityStateZip
                        ? ""
                        : `/Mailing Address`
                }:`}
            >
                {location.addressline1 && <div>{location.addressline1}</div>}
                {location.addressline2 && <div>{location.addressline2}</div>}
                {location.addressCityStateZip && (
                    <div>{location.addressCityStateZip}</div>
                )}
            </DetailsInfoSection>
        )}

        {location.mailingaddressline1 && location.addressCityStateZip && (
            <DetailsInfoSection heading="Mailing Address:">
                {location.addressline1 && (
                    <div>{location.mailingaddressline1}</div>
                )}
                {location.addressline2 && (
                    <div>{location.mailingaddressline2}</div>
                )}
                {location.mailingAddressCityStateZip && (
                    <div>{location.mailingAddressCityStateZip}</div>
                )}
            </DetailsInfoSection>
        )}

        {location.businesshourshtmltext && (
            <DetailsInfoSection heading="Hours:">
                <div
                    dangerouslySetInnerHTML={{
                        __html: location.businesshourshtmltext
                    }}
                />
            </DetailsInfoSection>
        )}

        {((location.branchPhones && location.branchPhones.length) ||
            location.branchemailaddress) && (
            <DetailsInfoSection heading="Contact Us:">
                <BranchPhones branchPhones={location.branchPhones} />
                Email:{" "}
                <a href={`mailto:${location.branchemailaddress}`}>
                    {location.branchemailaddress}
                </a>
            </DetailsInfoSection>
        )}

        {location.directionshtmltext && (
            <DetailsInfoSection heading="Directions:">
                <div
                    dangerouslySetInnerHTML={{
                        __html: location.directionshtmltext
                    }}
                />
            </DetailsInfoSection>
        )}

        <MoreLocationsWrapper>
            <UISref to="home">
                <a>More locations</a>
            </UISref>
        </MoreLocationsWrapper>
    </Wrapper>
);

export default DetailsInfo;



// WEBPACK FOOTER //
// ./components/details/DetailsInfo.jsx